import React, { useEffect, useState } from 'react'
import { Navigate, Link } from 'react-router-dom'
import firebase from "firebase/compat/app";

import { firebaseConfig } from './firebase'

import { doSignInWithEmailAndPassword, doSignInWithGoogle, doCreateUserWithEmailAndPassword } from './auth'
import { useAuth } from './authContext'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
firebase.initializeApp(firebaseConfig);

const Register = () => {
    const { userLoggedIn } = useAuth()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isSigningIn, setIsSigningIn] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isRegistering, setIsRegistering] = useState(false)
    const [confirmPassword, setconfirmPassword] = useState('')
    const [passcode, setPasscode] = useState(null);
    const options = ["Certified Orthotic Fitter", "Orthotist", "Masectomy Fitter", "Pedorthist", "Physical Therapist", "Nurse Practioner", "Doctor"];
    const [myValue, setMyValue] = useState(options[0]);    
    const [name, setName] = useState("");
    const [accessCode, setAccessCode] = useState("");
    const onSubmit = async (e) => {
        e.preventDefault()
        doCreateUserWithEmailAndPassword(email, password, myValue, name)
    }
    const handleChange = (event) => {
        setMyValue(event.target.value);
      };

      useEffect(() => {
        setTimeout(()=>{
    
        firebase
          .firestore()
          .collection("promo")
          .doc('mXsT8vSpfcUPE3vXUqH6')
          .get()
          .then((snapshot) => {
            if (snapshot.exists) {
            setPasscode(snapshot.data());
    
            } else {
              console.log("does not exist");
            }
          });
        }, 3000)
    }, []);
    console.log("passcode", passcode)

    

    if (passcode) {
        return (
            <div >
                {userLoggedIn && (<Navigate to={'/welcome'} replace={true} />)}
    
                <main className="w-full h-screen flex self-center place-content-center place-items-center">
                    <div className="w-96 text-gray-600 space-y-5 p-4 shadow-xl border rounded-xl bg-white">
                        
                        <div className="text-center mb-6">
                            
                            <div className="flex  justify-center items-center">
                            <img
                src="https://i.ibb.co/s2dBvDt/elevate.png"
                alt="logo"
                className='bg-white'
                width={500}
              ></img>                     </div>   
    
                        </div>
                        <form
                            onSubmit={onSubmit}
                            className="space-y-4"
                        >
                            <div>
                                <label className="text-sm text-gray-600 font-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    autoComplete='name'
                                    required
                                    value={name} onChange={(e) => { setName(e.target.value) }}
                                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-gray-600 font-bold">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    autoComplete='email'
                                    required
                                    value={email} onChange={(e) => { setEmail(e.target.value) }}
                                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                                />
                            </div>
    
                            <div>
                                <label className="text-sm text-gray-600 font-bold">
                                    Password
                                </label>
                                <input
                                    disabled={isRegistering}
                                    type="password"
                                    autoComplete='new-password'
                                    required
                                    value={password} onChange={(e) => { setPassword(e.target.value) }}
                                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
                                />
                            </div>
    
                            <div>
                                <label className="text-sm text-gray-600 font-bold">
                                    Confirm Password
                                </label>
                                <input
                                    disabled={isRegistering}
                                    type="password"
                                    autoComplete='off'
                                    required
                                    value={confirmPassword} onChange={(e) => { setconfirmPassword(e.target.value) }}
                                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
                                />
                            </div>
                            <div >
                                <div>
                            <label className="text-sm text-gray-600 font-bold">
                                    I am a..
                                </label>
                                </div>
                                <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={myValue}
              
              onChange={handleChange}
            >
              <MenuItem value={"Real Estate Agent"}>Real Estate Agent</MenuItem>
              <MenuItem value={"Aspiring Investor"}>Aspiring Investor</MenuItem>
              <MenuItem value={"Student"}>Student</MenuItem>
              
            </Select>
          </FormControl>
                                            
                                            </div>
    
                                            <div>
                                <label className="text-sm text-gray-600 font-bold">
                                    Access Code
                                </label>
                                <input
                                    
                                    type="input"
                                    autoComplete='off'
                                    required
                                    value={accessCode} onChange={(e) => { setAccessCode(e.target.value) }}
                                    className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
                                />
                            </div>
    
                            {/* <div >
                                <div>
                            <label className="text-sm text-gray-600 font-bold">
                                    Select Medical Role
                                </label>
                                </div>
                                <div className="mt-4">
                                            <select
                                                onChange={(e) => setMyValue(e.target.value)}
                                                defaultValue={myValue}
                                            >
                                                {options.map((option, idx) => (
                                                <option key={idx}>{option}</option>
                                                ))}
                                            </select>
                                            </div>
                                            
                                            </div> */}
    
                            
    
                            {errorMessage && (
                                <span className='text-red-600 font-bold'>{errorMessage}</span>
                            )}
                        { accessCode === passcode.passcode ?
                            <button
                                type="submit"
                                disabled={isRegistering}
                                className={`w-full px-4 py-2 text-white font-medium rounded-lg ${isRegistering ? 'bg-[#34b22c] cursor-not-allowed' : 'bg-[#34b22c] hover:border-5 hover:border hover:border-green-600 hover:bg-white hover:text-[#34b22c] hover:shadow-xl transition duration-300'}`}
                            >
                                {isRegistering ? 'Signing Up...' : 'Sign Up'}
                            </button>
                                :
                            <button
                            className={`w-full px-4 py-2 text-white font-medium rounded-lg ${isRegistering ? 'bg-[#34b22c] cursor-not-allowed' : 'bg-[#34b22c] hover:border-5  hover:bg-white hover:border-green-600 hover:border hover:text-[#34b22c] hover:shadow-xl transition duration-300'}`}
                            disabled
                            >
                               Sign Up
                            </button>
                            }
                        </form>
                    </div>
                </main>
            </div>
        )
    } else 
    return (
        <div></div>
    )
    
}

export default Register